<template>
  <div>
    <HtmlReader id="castle-conceptbooth" />
    <TitleLogo :title="productType === 'premium' ? '프리미엄 컨셉 보기' : '메이커샷 컨셉 보기'" />
    
    <!-- 상품 타입 전환 버튼 -->
    <!-- <v-sheet class="d-flex justify-center align-center py-2">
      <v-btn
        depressed
        class="font-weight-medium rounded-10 mr-2"
        width="140"
        :color="productType === 'makershot' ? '#ffaabe' : 'grey lighten-2 grey--text'"
        :dark="productType === 'makershot'"
        @click="$router.push('/castle/makershot')"
      >
        메이커샷
      </v-btn>

      <v-btn
        depressed
        class="font-weight-medium rounded-10"
        width="140"
        :color="productType === 'premium' ? '#ffaabe' : 'grey lighten-2 grey--text'"
        :dark="productType === 'premium'"
        @click="$router.push('/castle/premium')"
      >
        프리미엄
      </v-btn>
    </v-sheet> -->

    <v-sheet>
      <ConceptBooth :productType="productType" />
    </v-sheet>
  </div>
</template>
<script>
import TitleLogo from "@/views/components/TitleLogo"
import ConceptBooth from "./components/ConceptBooth"
import HtmlReader from "./components/HtmlReader"
import CastleQna from "./components/CastleQna"

const CASTLE_TABMENU = [
  {
    id: "conceptbooth",
    title: "page.conceptbooth.tab-title",
  },
  {
    id: "preserve-qna",
    title: "QNA",
  },
]

export default {
  components: {
    TitleLogo,
    ConceptBooth,
    HtmlReader,
    CastleQna,
  },
  props: {
    productType: {
      type: String,
      default: "makershot",
      validator: (value) => ["makershot", "premium"].includes(value),
    },
  },
  data: () => ({
    tabs: null,
    tabItems: CASTLE_TABMENU,
  }),
}
</script>
<style scoped>
.v-tab--active {
  color: black;
}
</style>
